import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=4d1a674b&scoped=true"
import script from "./Unsubscribe.vue?vue&type=script&lang=js"
export * from "./Unsubscribe.vue?vue&type=script&lang=js"
import style0 from "./Unsubscribe.vue?vue&type=style&index=0&id=4d1a674b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a674b",
  null
  
)

export default component.exports